import { createSelector } from 'reselect';

import { coworkingFixedWorkplaceWithErrorSelector } from './coworkingFixedWorkplaceWithErrorSelector';

export const coworkingFixedWorkplacePriceSelector = createSelector(
  coworkingFixedWorkplaceWithErrorSelector,
  fixed => fixed.price,
);
